import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const PUBLIC_BASE_URL = process.env.REACT_APP_PUBLIC_BASE_URL;

export const getDailyMessage = createAsyncThunk(
    'dailyMessage/getDailyMessage',
    async ({ skip, limit, search }, { rejectWithValue }) => {
        try {
            const params = {};

            if (skip !== undefined) params.skip = skip;
            if (limit !== undefined) params.limit = limit;
            if (search) params.search = search;

            const config = {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
                params,
            };

            const response = await axios.get(`${PUBLIC_BASE_URL}/daily-positive-messages`, config);
            console.log(response.data);
            return response.data;

        } catch (error) {
            console.log(error);
            if (error.message === 'Network Error') {
                return rejectWithValue({
                    response: {
                        data: {
                            message: 'Network Error',
                            status: error.code,
                        }
                    }
                });
            } else {
                return rejectWithValue({
                    message: 'Error',
                    status: error.code,
                });
            }
        }
    }
);